import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'report-hub',
  name: 'Report Hub',
  category: 'files',
  description: 'Publish reports to the Report Hub for viewing in the MFE. Supports HTML, PDF, images, and binary files.',
  icon: 'FileText',
  iconType: 'lucide',
  color: 'purple',
  version: '1.0.0',

  group: ['output'],

  inputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Input',
      required: true,
    },
  ],

  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Output',
    },
  ],

  subtitle: '={{ $parameter.reportName || "Report" }}',

  tags: ['report', 'publish', 'html', 'pdf', 'file', 'output', 'hub'],
};

export default definition;
